import type { SpinnerSize } from '@shared/ui/spinner';

import type { ButtonSize, ButtonVariant } from './button.ui';

/**
 * Figma `Button`(5:304) 에서 읽은 값. 색 · 테두리 · 모서리는 variant, 높이 · 좌우 여백 · 글자는 size 가 정한다.
 * hover · pressed 는 누를 수 있을 때만(`enabled:`) 켜진다. disabled 는 `disabled:` 로 덮는다.
 */
export const VARIANT_CLASS: Record<ButtonVariant, string> = {
  primary:
    'rounded-sm bg-bg-primary text-on-primary enabled:hover:bg-bg-primary-hover enabled:active:bg-bg-primary-pressed disabled:bg-bg-disabled disabled:text-fg-disabled',
  secondary:
    'rounded-sm bg-bg-secondary text-on-secondary enabled:hover:bg-bg-secondary-hover enabled:active:bg-bg-secondary-pressed disabled:bg-bg-disabled disabled:text-fg-disabled',
  outline:
    'rounded-sm border border-border-primary bg-bg-surface text-fg-primary enabled:hover:bg-bg-primary-subtle enabled:active:bg-bg-primary-subtle-hover disabled:border-border-default disabled:bg-bg-disabled disabled:text-fg-disabled',
  ghost:
    'rounded-sm text-fg-primary enabled:hover:bg-bg-primary-subtle enabled:active:bg-bg-primary-subtle-hover disabled:text-fg-disabled',
  danger:
    'rounded-sm bg-bg-danger text-on-danger enabled:hover:bg-bg-danger-hover enabled:active:bg-bg-danger-pressed disabled:bg-bg-disabled disabled:text-fg-disabled',
  'danger-outline':
    'rounded-sm border border-border-danger bg-bg-surface text-fg-danger enabled:hover:bg-bg-danger-subtle enabled:active:bg-bg-danger-subtle-hover disabled:border-border-default disabled:bg-bg-disabled disabled:text-fg-disabled',
  neutral:
    'rounded-sm border border-border-default bg-bg-surface text-fg-default enabled:hover:bg-bg-hover enabled:active:bg-bg-pressed disabled:bg-bg-disabled disabled:text-fg-disabled',
  'tonal-primary':
    'rounded-xl bg-bg-primary-subtle text-fg-primary enabled:hover:bg-bg-primary-subtle-hover enabled:active:bg-bg-primary-subtle-hover disabled:bg-bg-disabled disabled:text-fg-disabled',
  'tonal-danger':
    'rounded-xl bg-bg-danger-subtle text-fg-danger enabled:hover:bg-bg-danger-subtle-hover enabled:active:bg-bg-danger-subtle-hover disabled:bg-bg-disabled disabled:text-fg-disabled',
  'tonal-neutral':
    'rounded-xl bg-bg-muted text-fg-muted enabled:hover:bg-bg-pressed enabled:active:bg-bg-pressed disabled:bg-bg-disabled disabled:text-fg-disabled',
  inverse:
    'rounded-sm bg-bg-inverse text-fg-inverse disabled:bg-bg-disabled disabled:text-fg-disabled',
  'primary-pill':
    'rounded-full bg-bg-primary text-on-primary enabled:hover:bg-bg-primary-hover enabled:active:bg-bg-primary-pressed disabled:bg-bg-disabled disabled:text-fg-disabled',
};

/** 높이 · 좌우 여백 */
export const SIZE_CLASS: Record<ButtonSize, string> = {
  '2xs': 'h-(--size-control-2xs) px-2',
  xs: 'h-(--size-control-xs) px-2-5',
  sm: 'h-(--size-control-sm) px-3',
  md: 'h-(--size-control-md) px-4',
  lg: 'h-(--size-control-lg) px-5',
};

/** 글자 — 보통 variant */
export const TYPO_CLASS: Record<ButtonSize, string> = {
  '2xs': 'typo-caption',
  xs: 'typo-body-sm',
  sm: 'typo-body-sm',
  md: 'typo-body-sm',
  lg: 'typo-body-lg',
};

/** 글자 — tonal-* (굵은 글자) */
export const TYPO_STRONG_CLASS: Record<ButtonSize, string> = {
  '2xs': 'typo-caption-strong',
  xs: 'typo-caption-strong',
  sm: 'typo-body-sm-strong',
  md: 'typo-body-sm-strong',
  lg: 'typo-heading-4',
};

/** loading 때 겹치는 Spinner 크기(Figma: lg 만 md 24, 나머지 sm 16) */
export const SPINNER_SIZE: Record<ButtonSize, SpinnerSize> = {
  '2xs': 'sm',
  xs: 'sm',
  sm: 'sm',
  md: 'sm',
  lg: 'md',
};
